// Data + logik templat "Payment emails" (email automatik selepas bayar).
// Diasingkan daripada EmailTransaksiEditor.jsx supaya fail komponen hanya
// mengeksport komponen (peraturan lint react-refresh). Dipakai oleh
// EmailTransaksiEditor.jsx + EmailBlastTab.jsx.
//
// ⚠️ KEMBAR: TEMPLAT_LALAI + tanda ganti ada salinannya di server
//    `functions/emailTransaksi.js`. Tambah/ubah templat → ubah KEDUA-DUA fail.
// ⚠️ Setiap templat LALAI = MATI (keputusan user 2026-09-13: proofread dahulu).
import { useState, useEffect, useCallback } from 'react';
import { db } from '../firebase';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

const BUKA_APP = 'https://app.sesaat.ai';
export const HAD_SUBJEK = 200;
export const HAD_ISI = 10000;

// Susunan = susunan paparan. Isi email kekal Melayu — ia sampai kepada pelanggan.
export const TEMPLAT_LALAI = [
    {
        id: 'sesaat_new',
        nama: 'SESAAT — new subscription (Premium / Fighter / SMART)',
        bila: 'Sent when a new customer pays via Billplz, or when admin approves a manual transfer for a new customer.',
        subject: 'Pembayaran Berjaya — Selamat Datang ke SESAAT.AI',
        bodyText: `Hai {{nama}},\n\nTerima kasih! Pembayaran anda sebanyak **{{jumlah}}** untuk pakej **{{pakej}}** telah diterima.\n\nAkaun anda sudah aktif sehingga **{{tarikhTamat}}**. Tiada langkah tambahan diperlukan — terus log masuk dan mula.\n\n[Buka SESAAT.AI](${BUKA_APP})\n\nLangkah pertama: pasang extension SESAAT dari dashboard, kemudian ikut panduan di menu Tutorial.\n\nKunci lesen anda (untuk rekod): {{kunciLesen}}\n\nAda soalan? Balas email ini.`,
        tandaGanti: ['nama', 'emel', 'pakej', 'jumlah', 'kunciLesen', 'tarikhTamat', 'tempohHari'],
    },
    {
        id: 'sesaat_renew',
        nama: 'SESAAT — renewal',
        bila: 'Sent when an existing customer renews via Billplz, or when admin approves a manual renewal transfer.',
        subject: 'Langganan SESAAT.AI Anda Telah Disambung',
        bodyText: `Hai {{nama}},\n\nTerima kasih kerana terus bersama kami. Pembayaran **{{jumlah}}** untuk menyambung pakej **{{pakej}}** telah diterima.\n\nLangganan anda kini aktif sehingga **{{tarikhTamat}}**. Semua produk, prompt dan video anda kekal seperti sedia ada.\n\n[Buka SESAAT.AI](${BUKA_APP})\n\nAda soalan? Balas email ini.`,
        tandaGanti: ['nama', 'emel', 'pakej', 'jumlah', 'kunciLesen', 'tarikhTamat', 'tempohHari'],
    },
    {
        id: 'smart_upgrade',
        nama: 'SESAAT — SMART upgrade to Premium',
        bila: 'Sent when a SMART customer pays the RM100 upgrade to Premium.',
        subject: 'Naik Taraf ke Premium Berjaya',
        bodyText: `Hai {{nama}},\n\nPembayaran **{{jumlah}}** untuk naik taraf dari pakej SMART ke **Premium** telah diterima.\n\nSemua modul Premium kini dibuka pada akaun anda. Tarikh tamat langganan anda tidak berubah: **{{tarikhTamat}}**.\n\n[Buka SESAAT.AI](${BUKA_APP})\n\nAda soalan? Balas email ini.`,
        tandaGanti: ['nama', 'emel', 'jumlah', 'tarikhTamat'],
    },
    {
        id: 'flow_new',
        nama: 'Flow Ultra — new subscription',
        bila: 'Sent when a new Flow Ultra customer pays RM100. Credentials are still delivered manually by admin.',
        subject: 'Pembayaran Flow Ultra Diterima — Butiran Akaun Menyusul',
        bodyText: `Hai {{nama}},\n\nTerima kasih! Pembayaran **{{jumlah}}** untuk Akaun Flow Ultra telah diterima.\nNo. rujukan: {{noRujukan}}\n\n**Apa yang berlaku seterusnya:** admin kami akan menghantar butiran akaun Google anda melalui WhatsApp ({{whatsapp}}) dalam masa 24 jam.\n\nLangganan anda sah sehingga **{{tarikhTamat}}**.\n\nKalau tidak menerima butiran selepas 24 jam, balas email ini bersama no. rujukan di atas.`,
        tandaGanti: ['nama', 'emel', 'jumlah', 'tarikhTamat', 'noRujukan', 'whatsapp'],
    },
    {
        id: 'flow_renew',
        nama: 'Flow Ultra — renewal',
        bila: 'Sent when an existing Flow Ultra customer renews (+30 days, same Google account).',
        subject: 'Langganan Flow Ultra Disambung',
        bodyText: `Hai {{nama}},\n\nPembayaran **{{jumlah}}** untuk menyambung Akaun Flow Ultra telah diterima.\nNo. rujukan: {{noRujukan}}\n\nAkaun Google anda kekal sama — tiada perubahan diperlukan. Langganan kini sah sehingga **{{tarikhTamat}}**.\n\nAda soalan? Balas email ini.`,
        tandaGanti: ['nama', 'emel', 'jumlah', 'tarikhTamat', 'noRujukan', 'whatsapp'],
    },
];

// Nilai contoh untuk "Send test to me" — supaya email ujian nampak seperti email sebenar.
export const NILAI_CONTOH = {
    nama: 'Aisyah',
    emel: 'aisyah@contoh.com',
    pakej: 'Premium (Bulanan)',
    jumlah: 'RM199',
    kunciLesen: 'AI8-ABCD-1234',
    tarikhTamat: '13 Oktober 2026',
    tempohHari: '30',
    noRujukan: 'ORD1234567890',
    whatsapp: '+60 12-345 6789',
    // Hosted Flow — notifikasi batch (lihat useTemplatHosted.js)
    total: '9',
    berjaya: '8',
    perluSemakan: '1',
    gagal: '0',
};

export const PENERANGAN_TANDA = {
    nama: 'customer name (falls back to the part of the email before @)',
    emel: 'customer email',
    pakej: 'package name, e.g. Premium (Bulanan)',
    jumlah: 'amount paid, e.g. RM199',
    kunciLesen: 'license key',
    tarikhTamat: 'expiry date',
    tempohHari: 'duration in days',
    noRujukan: 'order reference',
    whatsapp: 'customer WhatsApp number',
    total: 'total videos in the batch',
    berjaya: 'videos that succeeded',
    perluSemakan: 'videos that need review',
    gagal: 'videos that failed',
};

export function isiTandaGanti(teks, vars) {
    return String(teks || '').replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, (_, k) => (vars[k] === undefined ? '' : String(vars[k])));
}

// Tanda ganti yang ditaip admin tetapi TIDAK dikenali server → nilai kosong pada
// email pelanggan. Ditangkap di sini supaya ia kelihatan SEBELUM disimpan.
function tandaTakDikenali(teks, dibenarkan) {
    const jumpa = new Set();
    String(teks || '').replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, (_, k) => { if (!dibenarkan.includes(k)) jumpa.add(k); return ''; });
    return [...jumpa];
}

// Nama pendek untuk baris menu kiri (lajur sempit ~180px). Nama penuh kekal dalam
// `nama` untuk tajuk borang. Sengaja peta berasingan — TEMPLAT_LALAI kekal sama
// bentuk dengan salinan server supaya ujian kembar mudah membandingnya.
export const NAMA_PENDEK = {
    sesaat_new: 'SESAAT — new',
    sesaat_renew: 'SESAAT — renewal',
    smart_upgrade: 'SMART upgrade',
    flow_new: 'Flow Ultra — new',
    flow_renew: 'Flow Ultra — renewal',
};

function binaItems(tersimpan) {
    return TEMPLAT_LALAI.map(t => {
        const s = (tersimpan && tersimpan[t.id]) || {};
        return {
            ...t,
            enabled: typeof s.enabled === 'boolean' ? s.enabled : false,
            subject: typeof s.subject === 'string' && s.subject.trim() ? s.subject : t.subject,
            bodyText: typeof s.bodyText === 'string' && s.bodyText.trim() ? s.bodyText : t.bodyText,
        };
    });
}

export function masalahTemplat(t) {
    const out = [];
    if (!t.subject.trim()) out.push('Subject is empty.');
    if (!t.bodyText.trim()) out.push('Message is empty.');
    if (t.subject.length > HAD_SUBJEK) out.push(`Subject is longer than ${HAD_SUBJEK} characters.`);
    if (t.bodyText.length > HAD_ISI) out.push(`Message is longer than ${HAD_ISI} characters.`);
    const asing = tandaTakDikenali(t.subject + '\n' + t.bodyText, t.tandaGanti);
    if (asing.length) out.push(`Unknown placeholder: ${asing.map(k => `{{${k}}}`).join(', ')} — it will appear EMPTY in the customer's email.`);
    return out;
}

// ── Satu sumber data untuk menu kiri + borang ──
// Satu sumber data untuk menu kiri + borang (titik ON/OFF menu tidak boleh terpesong dari borang).
// Simpan SATU templat = merge dalam ke `email_settings/transactional.templates.{id}` — templat lain tidak disentuh.
export function useTemplatTransaksi() {
    const [items, setItems] = useState(() => binaItems(null));
    const [loading, setLoading] = useState(true);
    const [ralat, setRalat] = useState('');

    const muat = useCallback(async () => {
        setLoading(true); setRalat('');
        try {
            const snap = await getDoc(doc(db, 'email_settings', 'transactional'));
            setItems(binaItems(snap.exists() ? (snap.data().templates || {}) : {}));
        } catch (e) {
            console.error('[EmailTxn] load failed:', e);
            setRalat('Failed to load saved templates: ' + e.message + ' — showing defaults (all OFF).');
            setItems(binaItems(null));
        } finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => { muat(); }, [muat]);

    // Simpan SATU templat. Merge dalam → templat lain dalam doc yang sama tidak disentuh.
    // Melontar bila data tidak sah atau tulisan gagal — pemanggil papar mesejnya.
    const simpanSatu = useCallback(async (t) => {
        const m = masalahTemplat(t);
        if (m.length) throw new Error(m.join(' '));
        await setDoc(doc(db, 'email_settings', 'transactional'), {
            templates: { [t.id]: { enabled: !!t.enabled, subject: t.subject, bodyText: t.bodyText } },
            updatedAt: serverTimestamp(),
        }, { merge: true });
        setItems(prev => prev.map(x => (x.id === t.id ? { ...x, enabled: !!t.enabled, subject: t.subject, bodyText: t.bodyText } : x)));
    }, []);

    return { items, loading, ralat, muat, simpanSatu };
}
